import './css/BrandAndStore.css'

import { useEffect, useState } from 'react'
import { useParams } from "react-router-dom"
import { Form, Button, Input, Modal, Upload, message, Space, Row, Col } from 'antd'
import { LoadingOutlined, PlusOutlined, EditOutlined } from '@ant-design/icons'
import { axiosHandleEvent, axiosTable } from '../../tool/axios'
import { apiPrefix } from '../../js/config'
import { formItemLayout, tailLayout, ngetBase64 } from '../../js/globalParam'
import Cookies from 'js-cookie'
import { Base64 } from 'js-base64'
import E from 'wangeditor'

function beforeUpload(file: { type: string; size: number }) {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'

    if (!isJpgOrPng) {
        message.error('只能上传JPG/PNG格式的图片文件!')
    }

    const isLt3M = file.size / 1024 / 1024 < 3

    if (!isLt3M) {
        message.error('上传图片不能大于3MB!')
    }

    return isJpgOrPng && isLt3M
}

export default function AddBrand() {

    let { id }: { id: string } = useParams()

    const [editorVisible, setEditorVisible] = useState<boolean>(false)
    const [formInstance] = Form.useForm()
    const [response, setResponse] = useState<any[]>([])
    const [editor, setEditor] = useState<null | E>(null)
    const [loading, setLoading] = useState<boolean>(false)

    const [previewImage, setPreviewImage] = useState<string>('')
    const [visible, setVisible] = useState<boolean>(false)

    const uploadButton = (
        <div>
            {loading ? <LoadingOutlined /> : <PlusOutlined />}
            <div style={{ marginTop: 8 }}>Upload</div>
        </div>
    )

    const handleModalOk = () => {
        let html = editor?.txt.html()
        formInstance.setFieldsValue({ brand_description: html })

        setEditorVisible(false)
    }

    const onFinish = (values: any) => {
        let url: string = '';
        values.brand_logo_url = values.brand_logo_url[0].response.data[0]

        if (id) {
            // 编辑
            let newObj: any = Object.assign(response, values)
            url = '/manage_center/brand/update'
            axiosHandleEvent.post(url, { id, ...newObj }).then(res => { })

        } else {
            // 新增
            url = '/manage_center/brand/add';
            axiosHandleEvent.post(url, { ...values }).then((res: any) => { })
        }
    }

    const showEditModal = () => {
        setEditorVisible(true)
    }

    const handlePreview = async (file: any) => {
        if (!file.url && !file.preview) {
            file.preview = await ngetBase64(file.originFileObj);

        } else {
            file.preview = file.url;
        }

        setPreviewImage(file.preview)
        setVisible(true)
    }

    const uploadFile = (e: { fileList: [] }) => {
        if (Array.isArray(e)) {
            return e
        }

        return e
            && e.fileList
    }
    const renderEditor = () => {
        const editor: any = new E('.editor')
        editor.config.uploadFileName = "files"
        editor.config.uploadImgServer = apiPrefix + '/global/upload_pic'

        editor.config.uploadImgParams = {
            fileType: 1,
            bucketType: 4
        }

        editor.config.uploadImgHeaders = {
            token: Cookies.get('token')
        }

        editor.config.uploadImgHooks = {
            // 例如，服务器端返回的不是 { errno: 0, data: [...] } 这种格式，可使用 customInsert
            customInsert: function (insertImgFn: any, result: any) {
                // result 即服务端返回的接口
                insertImgFn(result.data[0])
            }
        }
        editor.create()

        setEditor(editor)
        editor?.txt.html(formInstance.getFieldValue('brand_description'))
    }

    useEffect(() => {
        if (id) {
            axiosTable("/manage_center/brand/detail", { params: { id } }).then((res: any) => {
                res.brand_logo_url = [{ id: '', response: { data: [res.brand_logo_url] }, url: res.brand_logo_url }]
                res.brand_description = Base64.fromBase64(res.brand_description)

                setResponse(res)
                formInstance.setFieldsValue(res)
            })
        }
    }, [])

    useEffect(() => {
        if (editorVisible && editor === null) {
            renderEditor()
        }
    }, [editorVisible])

    return (<div className="common-level2-edit">
        <h2>{id ? '编辑' : '新增'}品牌</h2>

        <div className="common-main">
            <Form {...formItemLayout} form={formInstance} onFinish={onFinish}>
                <Form.Item label="品牌名称" name='brand_name' rules={[{ required: true, message: '必须输入品牌名称' }, () => ({
                    validator(_, value) {
                        if (!/\s/.test(value)) {
                            return Promise.resolve();
                        }
                        return Promise.reject(new Error('不能输入空格'));
                    },
                })]}>
                    <Input placeholder="请填写品牌名称" />
                </Form.Item>

                <Form.Item label="品牌编码" name="brand_code" rules={[{ required: true, message: '必须输入品牌编码' }, () => ({
                    validator(_, value) {
                        if (!/\s/.test(value)) {
                            return Promise.resolve();
                        }
                        return Promise.reject(new Error('不能输入空格'));
                    },
                })]}>
                    <Input placeholder="请填写品牌编码" />
                </Form.Item>

                <Form.Item label="客服电话" name="cs_phone" rules={[{ required: true, message: '必须输入客服电话' }, () => ({
                    validator(_, value) {
                        if (/^\d(?!(\d*-\d*){20}$)(\d|-){1,20}\d$/.test(value) || !value) {
                            return Promise.resolve();
                        }
                        return Promise.reject(new Error('不能输入空格、英文、汉字'));
                    },
                })]}>
                    <Input placeholder="请填写客服电话" />
                </Form.Item>

                <Form.Item
                    name="brand_logo_url"
                    label="品牌图片"
                    valuePropName="fileList"
                    getValueFromEvent={uploadFile}
                    rules={[{ required: true, message: '必须上传品牌图片' }]}
                >
                    <Upload
                        maxCount={1}
                        name="files"
                        onPreview={handlePreview}
                        beforeUpload={beforeUpload}
                        data={{ fileType: 1, bucketType: 4 }}
                        action={apiPrefix + '/global/upload_pic'}
                        listType="picture-card"
                    >
                        {uploadButton}
                    </Upload>
                </Form.Item>

                <Form.Item label="品牌详情" name="brand_description" rules={[{ required: true, message: '必须编辑品牌详情' }]}  >
                    <Button onClick={() => { showEditModal() }} icon={<EditOutlined />}>编辑</Button>
                </Form.Item>

                <Form.Item {...tailLayout}>
                    <Space>
                        <Button type="primary" htmlType="submit">提交</Button>
                        <Button onClick={() => { window.history.go(-1) }} >返回</Button>
                    </Space>
                </Form.Item>
            </Form>
        </div>

        <Modal
            visible={visible}
            title='浏览图片'
            footer={null}
            onCancel={() => { setVisible(false) }}
        >
            <img alt="example" style={{ width: '100%' }} src={previewImage} />
        </Modal>

        <Modal visible={editorVisible} onCancel={() => { setEditorVisible(false); }} width="800px" onOk={handleModalOk}>
            <div className="editor" style={{ marginTop: 50 }}></div>
        </Modal>
    </div>)
}